var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadable-container",class:{ loading: _vm.loading }},[(_vm.loading)?[_c('loader',{attrs:{"size":_vm.size}}),_c('div',[_vm._v(_vm._s(_vm.$t('common.loading')))])]:_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }